<template>
  <div class="content_box">
    <!-- 筛选查询框 -->
    <el-form :inline="true" size="mini">
      <el-form-item label="项目名称: ">
        <el-input
          v-model="listQuery.project_name"
          placeholder="请输入项目名称"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="唯一编码: ">
        <el-input v-model="listQuery.code" placeholder="请输入编码" style="width: 180px" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户手机号: ">
        <el-input
          v-model="listQuery.user_phone"
          placeholder="请输入手机号"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="用户openid: ">
        <el-input
          v-model="listQuery.user_openid"
          placeholder="请输入openid"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAdd">新增二维码</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="danger"
          :disabled="multipleSelection.length === 0"
          @click="handleBatchDelete"
        >批量删除</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
        >导出数据 Excel（{{ tableData.length }}）</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="batchDownloadLoading"
          :disabled="tableData.length === 0"
          type="success"
          icon="el-icon-download"
          @click="handleBatchDownloadQR"
        >批量下载二维码图片（{{ tableData.length }}）</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <ElTable
      :columns="listHeader"
      :tableData="tableData"
      :loading="loading"
      :total="listQuery.total"
      @selection-change="handleSelectionChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    >
      <template slot="operation" slot-scope="{ row }">
        <div class="operation">
          <el-button size="mini" type="text" @click="handlePreview(row)">预览</el-button>
          <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0);"
            @click="handleDelete(row)"
          >删除</el-button>
        </div>
      </template>
    </ElTable>

    <!-- 新增/编辑 Drawer -->
    <CommonDrawer
      :visible.sync="drawerVisible"
      :title="drawerTitle"
      size="400px"
      @confirm="handleDrawerConfirm"
      @cancel="handleDrawerCancel"
    >
      <el-form
        ref="drawerForm"
        :model="drawerForm"
        :rules="drawerRules"
        label-width="90px"
        size="small"
      >
        <el-form-item label="项目名称" prop="project_name">
          <el-input v-model="drawerForm.project_name" placeholder="请输入项目名称" style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item v-if="drawerMode === 'edit'" label="唯一编码">
          <el-input v-model="drawerForm.code" disabled></el-input>
        </el-form-item>

        <el-form-item label="积分" prop="point">
          <el-input-number
            v-model="drawerForm.point"
            :min="0"
            :precision="0"
            placeholder="请输入积分数量"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item v-if="drawerMode === 'add'" label="生成数量" prop="count">
          <el-input-number
            v-model="drawerForm.count"
            :min="1"
            :max="500"
            :precision="0"
            placeholder="批量生成数量，单次最多500"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item v-if="drawerMode === 'edit'" label="二维码链接">
          <el-input v-model="drawerForm.url_link" type="textarea" :rows="3" disabled></el-input>
        </el-form-item>-->
      </el-form>
    </CommonDrawer>

    <!-- 预览二维码弹窗 -->
    <el-dialog
      title="二维码预览"
      :visible.sync="previewVisible"
      width="360px"
      append-to-body
      @close="handleClosePreview"
    >
      <div class="qr-preview">
        <div v-if="previewLoading" v-loading="true" style="height: 220px;"></div>
        <img
          v-else-if="previewImageUrl && !imgError"
          :src="previewImageUrl"
          alt="二维码"
          class="qr-img"
          @error="handleImgError"
        />
        <div v-else-if="imgError" class="qr-link-fallback">
          <p style="color: #f56c6c; font-size: 12px;">加载失败</p>
        </div>
        <div class="qr-info" v-if="previewRow">
          <p>编码：{{ previewRow.code }}</p>
          <p>积分：{{ previewRow.point }}</p>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" @click="handleDownloadQR">下载二维码</el-button>
        <el-button size="small" type="primary" @click="handleClosePreview">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import CommonDrawer from "@/components/drawer/index.vue";
import listHeader from "./listHeader";
import {
  selectApi,
  addApi,
  updateApi,
  deleteApi,
  previewApi,
  batchDownloadApi
} from "@/services/pointsMall/pointQr";

export default {
  name: "PointCreateQR",
  components: {
    ElTable,
    CommonDrawer
  },

  async created() {
    this.getListData();
  },

  data() {
    return {
      listQuery: {
        code: "",
        user_phone: "",
        user_openid: "",
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      downloadLoading: false,
      batchDownloadLoading: false,

      // Drawer
      drawerVisible: false,
      drawerMode: "add",
      drawerForm: {
        code: "",
        point: 0,
        count: 1,
        url_link: ""
      },
      drawerRules: {
        point: [{ required: true, message: "请输入积分", trigger: "blur" }],
        count: [{ required: true, message: "请输入生成数量", trigger: "blur" }]
      },
      editRow: null,

      // 预览
      previewVisible: false,
      previewRow: null,
      previewImageUrl: "", // 预览图片的 Blob URL
      previewLoading: false,
      imgError: false
    };
  },

  computed: {
    listHeader,
    drawerTitle() {
      return this.drawerMode === "add" ? "新增二维码" : "编辑二维码";
    }
  },

  methods: {
    async getListData() {
      this.loading = true;
      try {
        // 去空格处理
        const queryParams = {
          ...this.listQuery,
          code: this.listQuery.code ? this.listQuery.code.trim() : "",
          user_phone: this.listQuery.user_phone
            ? this.listQuery.user_phone.trim()
            : "",
          user_openid: this.listQuery.user_openid
            ? this.listQuery.user_openid.trim()
            : ""
        };
        const { data, code, count } = await selectApi(queryParams);
        if (code === 200) {
          this.tableData = data || [];
          this.listQuery.total = count || 0;
        }
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      // 去除查询参数首尾空格
      this.listQuery.code = this.listQuery.code
        ? this.listQuery.code.trim()
        : "";
      this.listQuery.user_phone = this.listQuery.user_phone
        ? this.listQuery.user_phone.trim()
        : "";
      this.listQuery.user_openid = this.listQuery.user_openid
        ? this.listQuery.user_openid.trim()
        : "";
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    handleCurrentChange(page) {
      this.listQuery.pageNumber = page;
      this.getListData();
    },
    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.getListData();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    handleAdd() {
      this.drawerMode = "add";
      this.editRow = null;
      this.drawerForm = { code: "", point: 0, count: 1, url_link: "" };
      this.$nextTick(() => {
        this.$refs.drawerForm && this.$refs.drawerForm.clearValidate();
      });
      this.drawerVisible = true;
    },

    handleEdit(row) {
      this.drawerMode = "edit";
      this.editRow = row;
      this.drawerForm = {
        code: row.code,
        point: row.point,
        project_name: row.project_name
      };
      this.$nextTick(() => {
        this.$refs.drawerForm && this.$refs.drawerForm.clearValidate();
      });
      this.drawerVisible = true;
    },

    handleDrawerConfirm() {
      this.$refs.drawerForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          let resp;
          if (this.drawerMode === "add") {
            const { code, url_link, ...formData } = this.drawerForm;
            resp = await addApi(formData);
          } else {
            const { code, url_link, count, ...updateData } = this.drawerForm;
            resp = await updateApi({ ...updateData, id: this.editRow.id });
          }
          if (resp.code === 200) {
            this.$message.success(
              this.drawerMode === "add" ? "新增成功" : "修改成功"
            );
            this.drawerVisible = false;
            this.getListData();
          } else {
            this.$message.error(resp.msg || "操作失败");
          }
        } catch (err) {
          this.$message.error("操作失败");
        } finally {
          this.loading = false;
        }
      });
    },

    handleDrawerCancel() {
      this.drawerVisible = false;
    },

    handleDelete(row) {
      this.$confirm("此操作将永久删除该记录，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.loading = true;
          try {
            const resp = await deleteApi({ id: row.id });
            if (resp.code === 200) {
              this.$message.success("删除成功");
              this.getListData();
            }
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {});
    },

    async handleBatchDelete() {
      if (!this.multipleSelection.length) {
        return this.$message.warning("请先选择要删除的记录");
      }
      try {
        await this.$confirm(
          `此操作将删除选中的 ${this.multipleSelection.length} 条记录，是否继续？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
      } catch (e) {
        return;
      }
      const ids = this.multipleSelection.map(i => i.id).filter(Boolean);
      if (!ids.length) return;
      this.loading = true;
      try {
        const resp = await deleteApi({ id: ids });
        if (resp.code === 200) {
          this.$message.success("批量删除成功");
          this.multipleSelection = [];
          this.getListData();
        }
      } catch {
        this.$message.error("删除失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    async handlePreview(row) {
      this.previewRow = row;
      this.imgError = false;
      this.previewVisible = true;
      this.previewLoading = true;
      this.previewImageUrl = "";

      try {
        // 调用预览接口获取图片流
        const blob = await previewApi(row.code);

        // 将 Blob 转为可显示的 URL
        this.previewImageUrl = URL.createObjectURL(blob);
      } catch (err) {
        console.error("预览二维码失败", err);
        this.imgError = true;
      } finally {
        this.previewLoading = false;
      }
    },

    handleImgError() {
      this.imgError = true;
    },

    handleDownloadQR() {
      if (!this.previewImageUrl) return;
      const link = document.createElement("a");
      link.href = this.previewImageUrl;
      link.download = `qr_${this.previewRow.code || "code"}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleClosePreview() {
      // 释放 Blob URL 以避免内存泄漏
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = "";
      }
      this.previewVisible = false;
    },

    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then(excel => {
        const tHeader = ["唯一编码", "积分", "二维码图片", "创建时间"];
        const filterVal = ["code", "point", "url_link", "create_time"];
        const data = this.formatJson(filterVal, this.tableData);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "积分二维码列表",
          autoWidth: true,
          bookType: "xlsx"
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    async handleBatchDownloadQR() {
      if (!this.tableData || this.tableData.length === 0) {
        return this.$message.warning("暂无数据可下载");
      }

      // 检查数量限制
      if (this.tableData.length > 500) {
        return this.$message.warning("单次最多下载500张二维码，请先筛选数据");
      }

      try {
        await this.$confirm(
          `即将下载 ${this.tableData.length} 张二维码图片（ZIP压缩包），是否继续？`,
          "提示",
          { confirmButtonText: "确定", cancelButtonText: "取消", type: "info" }
        );
      } catch (e) {
        return;
      }

      this.batchDownloadLoading = true;

      try {
        // 提取所有 code
        const codes = this.tableData.map(item => item.code).filter(Boolean);

        if (codes.length === 0) {
          this.$message.warning("没有有效的二维码编码");
          return;
        }

        // 调用批量下载接口
        const blob = await batchDownloadApi(codes);

        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `qrcodes_${new Date().getTime()}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 释放 Blob URL
        URL.revokeObjectURL(url);

        this.$message.success(`成功下载 ${codes.length} 张二维码图片`);
      } catch (err) {
        console.error("批量下载二维码失败", err);
        this.$message.error("批量下载失败，请重试");
      } finally {
        this.batchDownloadLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.content_box {
  margin: 0 auto;
  width: 100%;
}

.operation {
  display: flex;
  align-items: center;
  gap: 4px;
}

.qr-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

.qr-img {
  width: 220px;
  height: 220px;
  object-fit: contain;
  border: 1px solid #eee;
  border-radius: 4px;
}

.qr-link-fallback {
  width: 220px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 4px;
  text-align: center;
}

.qr-info {
  margin-top: 16px;
  text-align: center;
  color: #606266;
  font-size: 13px;
}

.qr-info p {
  margin: 4px 0;
}
</style>